import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  { name: "title", label: "Title", required: true, showInTable: true },
  { name: "slug", label: "Slug" },
  { name: "category", label: "Category", showInTable: true },
  { name: "author", label: "Author", showInTable: true },
  {
    name: "publish_date",
    label: "Publish Date",
    type: "date",
    showInTable: true,
  },
  { name: "short_description", label: "Short Description", type: "textarea" },
  { name: "full_description", label: "Full Content", type: "textarea" },
  { name: "featured_image", label: "Featured Image URL", type: "url" },
  { name: "seo_title", label: "SEO Title" },
  { name: "seo_description", label: "SEO Description", type: "textarea" },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "published", label: "Published" },
      { value: "draft", label: "Draft" },
    ],
    showInTable: true,
  },
];

export default function Page() {
  return (
    <AdminShell title="Posts" subtitle="News & feed posts">
      <ResourceTable
        table="posts"
        title="Post"
        fields={fields}
        searchFields={["title", "category", "author"]}
        orderBy="publish_date"
      />
    </AdminShell>
  );
}
